<template>
  <div>
    <Pos_inventory_list/>
  </div>
</template>

<script>
import Pos_inventory_list from "@/components/adminArin/pos_system/warehouse/inventory/Pos_inventory_list";
export default {
  name: "PosInventoryList",
  components: {
    Pos_inventory_list
  }
}
</script>

<style scoped>

</style>
